import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import CardSection from "@components/core/section/CardSection";
import LinkButton from "@components/core/links/LinkButton";
import { ROUTES } from "@routes/Routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "antd";
import { TransactionDetail } from "@/type/core/transaction/transaction.types";

interface ProcessScellementSectionProps {
  transaction: TransactionDetail;
  className?: string;
}

const ProcessScellementSection: FunctionComponent<
  ProcessScellementSectionProps
> = ({ transaction, className = "" }) => {
  const { t } = useTranslation();
  const numbers = transaction && transaction.progression?.split("/");
  let total;
  let current;
  if (numbers) {
    total = numbers[1];
    current = numbers[0];
  }
  const finished = transaction && transaction.status === "finished";
  const tsError = transaction && transaction.tsError;

  return (
    <CardSection
      title={
        t("process.scellement.title") +
        (finished ? "" : t("process.scellement.titleInProgress"))
      }
      titleClassName="h1 mb-8"
      className={`app-section-process-scellement ${className}`}
    >
      <>
        <div className="d-flex mb-16">
          <strong className={finished ? "text-success" : "text-warning"}>
            {finished
              ? t("process.scellement.finishedTitle")
              : tsError
                ? t("process.scellement.error")
                : t("process.scellement.inProgress")}
          </strong>
          {!finished && (
            <div className="ml-48 text-black d-flex fas fa-hourglass-half">
              <FontAwesomeIcon icon={faHourglassHalf} size="4x" />
            </div>
          )}
        </div>
        <div className="mb-16">
          {finished
            ? t("process.scellement.finished")
            : tsError
              ? t("process.scellement.unavailable")
              : t("process.scellement.unavailableMessage")}
        </div>
        <Row className="mb-16">
          <Col span={24} md={10}>
            <Row gutter={30}>
              <Col span={24} md={18}>
                {t("process.scellement.numberOfDocuments")}
              </Col>
              <Col span={24} md={6}>
                {total}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mb-16">
          <Col span={24} md={10}>
            <Row gutter={30}>
              <Col span={24} md={18}>
                {t("process.scellement.numberOfDocumentsTreated")}
              </Col>
              <Col span={24} md={6}>
                {current}
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="text-danger mb-16">
          {finished && current !== total
            ? t("process.scellement.errorScellementDocuments")
            : ""}
        </div>
        {transaction.sealMoved && (
          <div className="text-danger mb-16">
            {t("process.scellement.sealMoved")}
          </div>
        )}
        <div className="d-flex justify-content-center flex-wrap pt-24">
          <LinkButton
            to={ROUTES.extranet.home.generate()}
            variant="tertiary"
            className="mt-24 mx-24 py-8 px-30 mh-42 font-extra-small"
            text={t("process.scellement.back")}
          />
          {finished && (
            <LinkButton
              to={ROUTES.extranet.transactions.details.generate(transaction.id)}
              variant="tertiary"
              className="mt-24 mx-24 py-8 px-30 mh-42 font-extra-small"
              text={t("process.scellement.toTransaction")}
            />
          )}
        </div>
      </>
    </CardSection>
  );
};

export default ProcessScellementSection;
